import { fetcher, queryString, useRecoilQuery } from '@shared/hooks/recoil-query';

import {
  funeralHomeInfoDataAtomFamily,
  funeralHomeInfoListDataAtom,
  funeralHomeInfoListStatusAtom,
  funeralHomeInfoStatusAtomFamily,
} from './funeralHomeInfo.atom';

export const funeralHomeInfoListHookUrl = `public/funeral-home-info`;

//* 목록은 부고 작성 검색 모달까지 쓰는 전체 목록이라 populate를 붙이지 않는다(무거워진다)
export const useFuneralHomeInfoListHook = () => {
  useRecoilQuery(
    funeralHomeInfoListStatusAtom,
    funeralHomeInfoListDataAtom,
    funeralHomeInfoListHookUrl,
    fetcher,
  );
};

//* 단건 — 추가정보 사진까지 populate.
//* ⚠️ 백엔드에 additionalInfos 스키마가 없는 서버에서는 StrictPopulateError로 500이 난다.
//* 쓰는 쪽에서 status === 'error'면 목록 데이터로 폴백할 것.
export const funeralHomeInfoUrl = (funeralHomeInfoId: string) =>
  `public/funeral-home-info/${funeralHomeInfoId}?${queryString({
    populate: ['additionalInfos.image'],
  })}`;

export const useFuneralHomeInfoHook = (funeralHomeInfoId: string, disabled?: boolean) => {
  useRecoilQuery(
    funeralHomeInfoStatusAtomFamily(funeralHomeInfoId),
    funeralHomeInfoDataAtomFamily(funeralHomeInfoId),
    funeralHomeInfoUrl(funeralHomeInfoId),
    fetcher,
    disabled,
  );
};
